import {
  ACOES_AVALIACAO,
  type EtapaAvaliacao,
  type FichaVitimaAtendimento,
  type ProblemaClinicoFicha,
} from '../../dominio/tabletop/atendimento'

/** Agrupa textos já cadastrados; não cria indicações nem efeitos clínicos. */
export function condutasDaFicha(ficha: FichaVitimaAtendimento): ReadonlyMap<EtapaAvaliacao, readonly string[]> {
  const grupos = new Map<EtapaAvaliacao, string[]>()
  const incluir = (etapa: EtapaAvaliacao, texto: string) => {
    grupos.set(etapa, [...(grupos.get(etapa) ?? []), texto])
  }

  for (const texto of ficha.intervencoesCitadas) incluir(etapaDaConduta(texto), texto)
  for (const problema of ficha.problemas ?? []) {
    const regras = ficha.regrasEfeito?.filter(r => r.idProblema === problema.id) ?? []
    if (regras.length === 0) continue
    incluir(etapaDoProblema(problema), `${problema.rotulo}: ${regras.map(r => r.explicacao).join(' ')}`)
  }
  return grupos
}

function etapaDaConduta(texto: string): EtapaAvaliacao {
  const normalizado = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  if (/torniquete|compressao direta|curativo|hemorragia/.test(normalizado)) return 'X'
  if (/colar|cervical|via aerea|aspiracao|canula|intubacao/.test(normalizado)) return 'A'
  if (/oxigen|o[₂2]|ventil|bvm|torac|pneumotorax/.test(normalizado)) return 'B'
  if (/acesso|venoso|soro|fluido|pelvic|monitor|transporte/.test(normalizado)) return 'C'
  if (/manta|hipoterm|aquec|exposicao/.test(normalizado)) return 'E'
  return 'secundaria'
}

export function etapaDoProblema(problema: ProblemaClinicoFicha): EtapaAvaliacao {
  // O efeito é mostrado na primeira etapa cujo exame ele modifica.
  const alterados = new Set(Object.values(problema.achadosPorEstado ?? {}).flatMap(achados => Object.keys(achados)))
  const acao = ACOES_AVALIACAO.find(a => alterados.has(a.id))
  if (acao) return acao.etapa
  switch (problema.regiao) {
    case 'torax': return 'B'
    case 'abdomen':
    case 'pelve': return 'C'
    case 'cabeca': return 'D'
    case 'corpoTodo': return 'E'
    default: return 'secundaria'
  }
}
